import axios from 'axios';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { Session, Local } from '/@/utils/storage';
import { loginYzmCode } from '/@/utils/storage';

// 配置新建一个 axios 实例
// console.log(import.meta.env.VITE_API_URL)
const service = axios.create({
    baseURL: '/',
    timeout: 50000,
    headers: { 'Content-Type': 'application/json' },
});

// 添加请求拦截器
service.interceptors.request.use(
    (config) => {
        if (Session.get('token')) {
            // (<any>config.headers).common['Authorization'] = `Bearer ${Session.get('token')}`;
            config.headers['Authorization'] = `Bearer ${Session.get('token')}`;
        }
        // (<any>config.headers).common['A-Client-Id'] = `80j$8A!Q4s4QuHwoQa70vypBCYoQ2r7M`;
        config.headers['A-Client-Id'] = `80j$8A!Q4s4QuHwoQa70vypBCYoQ2r7M`;
        // axios 1.x 升级适配：实例默认的 Content-Type: application/json 会使 transformRequest
        // 将 FormData 序列化为 JSON 字符串（文件流丢失），导致文件上传类接口失败；
        // 检测到 FormData 时移除该默认头，交由 axios/浏览器自动设置 multipart/form-data（含 boundary）
        if (config.data instanceof FormData) {
            const headers = config.headers as any;
            if (typeof headers.delete === 'function') {
                headers.delete('Content-Type'); // axios 1.x（headers 为 AxiosHeaders）
            } else {
                delete headers['Content-Type']; // axios 0.x（headers 为普通对象）
            }
        }
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
service.interceptors.response.use(
    (response) => {
        // 对响应数据做点什么
        const res = response.data;
        const skipErrorHandle = response.config.skipErrorHandle || false;

        if (res.code && res.code !== 10000) {
            // `token` 过期或者账号已在别处登录
            if (res.code === 401 || res.code === 4001) {
                Session.clear(); // 清除浏览器全部临时缓存
                window.location.href = '/'; // 去登录页
                ElMessageBox.alert('你已被登出，请重新登录', '提示', {})
                    .then(() => { })
                    .catch(() => { });
            }
            else {
                const response = res || {};
                if(skipErrorHandle === true && response?.code===loginYzmCode){
                }else{
                    ElNotification({
                        title: `错误代码: ${res.code}`,
                        type: 'error',
                        message: res.msg
                    })
                }
                
                return { 
                    data: null, 
                    code: response?.code, // 直接在这里获取业务错误码
                    message: response?.message,
                    status: response?.status || 0 
                };
                return Promise.reject(service.interceptors.response);
            }
        } else {
            // 如果是下载文件的响应数据，则直接返回
            
            if(response.data.type){
                return response
            }
            return response.data;
        }
    },
    (error) => {
        // 对响应错误做点什么
        if (error.message.indexOf('timeout') != -1) {
            ElMessage.error('网络超时');
        } else if (error.message == 'Network Error') {
            ElMessage.error('网络连接错误');
        } else {
            if (error.response.status === 401) {
                Session.clear();
                window.location.href = '/'; // 去登录页
            }
            if (error.response.data) ElMessage.error(error.response.statusText);
            else ElMessage.error(error.response.status);

       
        }
        return Promise.reject(error);
    }
);

// 导出 axios 实例
export default service;